import { padding, PaddingProps } from '@lib/style/mixins/padding';
import { position, PositionProps } from '@lib/style/mixins/position';
import { createMemo } from '@packages/react';
import { applyRef } from '@packages/react/applyRef';
import React, { ElementType, forwardRef, HTMLAttributes } from 'react';
import styled from 'styled-components';

export interface PositionedBoxProps<K extends ElementType = any>
    extends Partial<PaddingProps & PositionProps>,
        HTMLAttributes<HTMLDivElement> {
    children?: any;
    component?: K;

    [key: string]: any;
}

export const PositionedBox = styled(
    createMemo<PositionedBoxProps>(
        forwardRef((props, ref) => {
            const { children, component, ...rest } = props;

            const Component = component!;

            padding.clean(rest);
            position.clean(rest);
            applyRef(rest, ref);

            return <Component {...rest}>{children}</Component>;
        }),
        {
            displayName: 'PositionedBox',
            defaultProps: {
                component: 'div',
                position: 'relative',
            },
        },
    ),
)<PositionedBoxProps>`
    & {
        ${padding()};
        ${position('absolute')};
    }
`;
